/**
 * Entry point pro React komponenty → js/react.min.js
 *
 * Novou komponentu vytvoř v assets/react/components/ a zaregistruj ji zde.
 * V Latte pak stačí: <div data-react-component="NazevKomponenty" data-props='{...}'></div>
 */
import { register, mountAll, unmountAll } from '@react/mount';

import CheckoutForm from '@components/checkout/CheckoutForm';
import BasketSummarySide from '@components/basket/BasketSummarySide';
import DeliveryPaymentStep from '@components/delivery/DeliveryPaymentStep';
import VratkyApp from '@components/vratky/VratkyApp';

register('CheckoutForm', CheckoutForm);
register('BasketSummary', BasketSummarySide);
register('DeliveryPaymentStep', DeliveryPaymentStep);
register('VratkyApp', VratkyApp);

// Mount po načtení stránky
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountAll());
} else {
    mountAll();
}

// Globální API pro re-mount po překreslení AJAX snippetů (nette.ajax)
declare global {
    interface Window {
        ReactMount: {
            mountAll: typeof mountAll;
            unmountAll: typeof unmountAll;
        };
    }
}

window.ReactMount = { mountAll, unmountAll };
